// extracted by mini-css-extract-plugin
var _1 = "O491K";
var _2 = "SmMkL";
var _3 = "_cO4e";
var _4 = "BCJHf";
export { _1 as "base", _2 as "variant-error", _3 as "variant-info", _4 as "variant-warning" }
